import React from 'react';
import { Link } from 'react-router-dom';

const GetInTouch = () => {
    return (
        <div className='container'>
            <div className="mt-5 text-center">
                <h1 className="textColor text-center"> Get In Touch</h1>
                <div className="mx-auto col-md-8">
                    <p  style={{ color: '#ccd6f6' }}>I'd Love to hear from you . Whether you have a question or just want to say hi, fell free to drop a message. I'll try my best to get back to you!</p>
                </div>
                <Link class="d-inline-block my-4" to="/contact"><button type="button" class="btn btn-outline-success btn-lg textColor">Send Message</button></Link>
                
            </div>
        </div>
    );
};

export default GetInTouch;